import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, mergeProps as _mergeProps, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6b22c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "",
  style: {"height":"74px"},
  id: "v-step-resumo-tab-notas-close"
}
const _hoisted_2 = { class: "d-flex justify-space-between align-center h-100 px-8 v-step-close-modal" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = {
  class: "body-modal",
  style: {"padding":"0 15px 15px 15px"}
}
const _hoisted_5 = { class: "border container-table bg-white" }
const _hoisted_6 = { class: "row-table-" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "me-2"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["placeholder", "onUpdate:modelValue", "onChange", "onBlur", "onFocus"]
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = {
  key: 0,
  class: "w-100"
}
const _hoisted_17 = { class: "text-white my-auto" }

import { withDefaults, ref, watch, onMounted, computed } from 'vue';
import { IHeadersTable, IOptionsSelect } from '@/types';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import { VueGoodTable } from 'vue-good-table-next';
import { MoleculePagination, MoleculeTooltipMetas } from '@/components/molecules';
import {
    AtomBadge,
    AtomPhasedProgress,
    AtomInput,
    AtomInputMoney,
    AtomSelect,
    AtomAvatarOverlay,
    LoaderIcon,
    ChevronSolidIcon,
    AtomTitle,
    AtomButton
} from '../atoms';
import Swal from 'sweetalert2';import { Preloader } from '@/store';
import { formatCurrency } from '@/utils/formatNumber';
import { getLanguage } from "@/utils/locale";
import { messages } from "@/utils/i18n";
import { updateMonthItems } from '@/core/service/ItemsService';
import { showModalQuotation } from '@/store/modules/subBar';

interface IProps {
    // Modal
    show: any;
    disabled?: boolean;
    width?: string;
    heigth?: string;
    icon?: string;
    iconColor?: string;
    el?: any;
    title: string;
    subtitle?: string;
    btnCloseText?: string;
    btnConfirmText?: string;
    paddingY?: string;
    btnConfitmDisabled?: boolean;
    hasBtnClose?: boolean;
    hasBtnConfirm?: boolean;
    showFooter?: boolean;
    persistent?: boolean;
    showHeader?: boolean;
    closeBody?: boolean;

    // Accordion Table
    headers: Array<IHeadersTable>;
    items: any[];
    filters?: boolean;
    enableOptions?: boolean;
    disableSelectInfo?: boolean;
    selectOnCheckboxOnly?: boolean;
    textEmpty?: string;
    selectedClass?: string;
    indexSelect?: number;
    perPage?: number;
    page?: number;
    totalItems?: number;
    update?: boolean;
    pagination?: boolean;
    loading?: boolean;
    itemSelect?: any;
    hasOptions?: boolean;
    isFinanceira?: boolean;
    // checkbox?: boolean;
    enableExpand?: boolean;

    enableButtons?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalAccordionTable',
  props: {
    show: {},
    disabled: { type: Boolean, default: false },
    width: { default: '600px' },
    heigth: {},
    icon: {},
    iconColor: {},
    el: { default: 'div' },
    title: {},
    subtitle: {},
    btnCloseText: { default: 'Cancel' },
    btnConfirmText: { default: 'Import' },
    paddingY: { default: '0px' },
    btnConfitmDisabled: { type: Boolean },
    hasBtnClose: { type: Boolean, default: true },
    hasBtnConfirm: { type: Boolean, default: true },
    showFooter: { type: Boolean, default: true },
    persistent: { type: Boolean, default: true },
    showHeader: { type: Boolean, default: true },
    closeBody: { type: Boolean, default: false },
    headers: {},
    items: {},
    filters: { type: Boolean, default: false },
    enableOptions: { type: Boolean },
    disableSelectInfo: { type: Boolean },
    selectOnCheckboxOnly: { type: Boolean },
    textEmpty: { default: 'No information to display' },
    selectedClass: { default: '' },
    indexSelect: {},
    perPage: { default: 10 },
    page: { default: 1 },
    totalItems: { default: 0 },
    update: { type: Boolean, default: false },
    pagination: { type: Boolean, default: true },
    loading: { type: Boolean },
    itemSelect: {},
    hasOptions: { type: Boolean, default: true },
    isFinanceira: { type: Boolean },
    enableExpand: { type: Boolean, default: true },
    enableButtons: { type: Boolean }
  },
  emits: [
    // Modal
    'handleCancel', 'handleConfirm',
    // Accordion Table
    'handleUpload', 'rowClick', 'changePerPage', 'changePage', 'updateRow', 'searching', 'handleSort', 'blur'
],
  setup(__props: any, { emit: __emit }) {

;
let locale: string = messages[getLanguage()]['message'];

const emit = __emit;

const props = __props;

const showEditDate = ref<boolean>(false);
const table = ref(null);
const search = ref<string>('');
const updateValues = ref<any>({});
const page = ref(1);
const perPageTable = ref(10);
const lengthItems = computed(() => {
    return Math.ceil(props.totalItems / perPageTable.value)
});

let pagination = {
    enabled: true,
    mode: 'records',
    perPage: perPageTable.value,
};

const computedItems = computed(() => {
    return props.items.filter(x => x.archived ? x.archived === 0 : true)
});

const dialog = ref<boolean>(props.show);

const selectedRows = ref([]);

const itemsUpdates = ref<object[]>([]);

const newDate = ref<Date>();

const dateComputed = computed(() => {
    return [{ text: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toLocaleString('default', { month: 'long' }), value: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1) } as IOptionsSelect];
});

function handleUpdate(id, invoiceId, oldValue, value) {
    const itemOBJ: object = { itemId: id, invoiceId: invoiceId, oldValue: oldValue, newValue: formatCurrency((value).replaceAll(',', '')).toLocaleString() };
    //Procura pelo item na lista, para caso já tenha sido inserido, ele vai atualizar
    const itemIndex = itemsUpdates.value.findIndex(item => item["itemId"] === itemOBJ["itemId"]);

    if (value === '' || value === null) {
        // Campo zerado
        // Se o valor estiver vazio, removemos do updateValues
        itemsUpdates.value.splice(itemIndex, 1);
    } else {
        if (itemIndex !== -1) {
            // Item duplicado encontrado!
            itemsUpdates.value[itemIndex] = itemOBJ;
        } else {
            // Novo item inserido!
            itemsUpdates.value.push(itemOBJ);
        }
    }
}

function unformatCurrency(value) {
    return Number((value.replaceAll('$', '')).replaceAll(',', ''));
}

function blurMargin(value) {
    return value != '' ? formatCurrency(Number(value.includes(',') ? value.replaceAll(',', '') : value)) : value;
}

function handleConfirm() {
    emit('handleConfirm');
}

function close() {
    updateValues.value = [];
    itemsUpdates.value = []; 
    emit('handleCancel', 'fecha');
}

function rowStyleClassFn(row) {
    let clss = `${(row.due_date ? (new Date() > new Date(row.due_date) ? 'background-red' : '') : '')} ${(props.items[0].id == row.id ? 'v-step-row-modal-tutorial' : '')}`;

    return clss;
}

function validLine(row) {
    return props.indexSelect && row.id == props.indexSelect;
}

function onRowClick(params) {
    if (props.enableOptions) {
        selectedRows.value.push(params.row.id);
    }
    emit('rowClick', params);
}

function selectionChanged(params) {
    console.log('selected row', params);
}

function onSortChange(params) {
    emit('handleSort', {
        type: params[0].type,
        field: params[0].field,
    });
}

function submitEditDate() {
    if (itemsUpdates.value.length === 0) {
        Swal.fire({
            icon: "warning",
            title: locale['common']['atention'],
            text: locale['edit_invoice']['warning_message']
        });
        itemsUpdates.value = [];
    } else {
        dialog.value = false;
        Swal.fire({
            title: '<strong>' + locale['common']['atention'] + '</strong>',
            icon: 'question',
            html: locale['edit_invoice']['verify_message'],
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: locale['common']['continue'],
            cancelButtonText: locale['common']['no'],
            input: "text",
            inputLabel: locale['common']['type_confirm'],
            inputAutoFocus: true,
            inputValidator: (value) => {
                if (!value) {
                    return locale['common']['word_validation'];
                }
                else if (value.toLocaleUpperCase() !== "SIM" && value.toLocaleUpperCase() !== "YES" && value.toLocaleUpperCase() !== "SÍ") {
                    return locale['common']['word_validation_error'];
                }
            }
        })
            .then((ale) => {
                if (ale.isConfirmed && (ale.value?.toLocaleUpperCase() === "SIM" || ale.value?.toLocaleUpperCase() === "YES" || ale.value?.toLocaleUpperCase() === "SÍ")) {
                    Preloader.actions.ActionSetPreloader(true);

                    updateMonthItems({ items: itemsUpdates.value }).then(f => {
                        Swal.fire({
                            text: locale['edit_invoice']['success_message'],
                            title: locale['common']['success'],
                            icon: 'success'
                        });
                        window.location.reload();
                    })
                        .finally(() => {
                            Preloader.actions.ActionSetPreloader(false);
                        })
                }

                showEditDate.value = false;
                selectedRows.value = [];
                updateValues.value = [];
                newDate.value = undefined;
                itemsUpdates.value = [];
            });
    }
}

function clearValues(){ 
    updateValues.value = [];
    itemsUpdates.value = []; 
}

onMounted(() => {
    updateValues.value = [];
    page.value = props.page;
    perPageTable.value = props.perPage;

    if (props.itemSelect) {
        props.headers
            .filter((f) => !!f.update)
            .map((x) => {
                updateValues.value[String(x.update)] = props.itemSelect[String(x.update)];
            });
    }
});

watch(
    () => page.value,
    () => {
        emit('changePage', page.value);
    }
);

watch(
    () => props.page,
    () => {
        page.value = props.page;
    }
);

watch(
    () => perPageTable.value,
    () => {
        emit('changePerPage', perPageTable.value);
    }
);

watch(
    () => props.perPage,
    () => {
        perPageTable.value = props.perPage;
    }
);

watch(
    () => updateValues.value,
    () => {
        emit('updateRow', updateValues.value);
    },
    { deep: true }
);

watch(
    () => search.value,
    () => {
        emit('searching', search.value);
    }
);

watch(
    () => props.itemSelect,
    () => {
        if (props.itemSelect) {
            updateValues.value = {};

            const data: any = {};

            props.headers
                .filter((f) => !!f.update)
                .map((x) => {
                    data[String(x.update)] = props.itemSelect[String(x.update)];
                });
            updateValues.value = data;
        }
    }
);

watch(
    () => props.show,
    () => (dialog.value = props.show)
);
watch(
    () => dialog.value,
    (nvalue) => {
        if (!nvalue) emit('handleCancel', dialog.value);
    }
);


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialog).value = $event)),
    persistent: props.persistent,
    width: props.width,
    height: props.heigth,
    id: "v-step-resumo-tab-notas"
  }, {
    default: _withCtx(() => [
      (_ctx.showHeader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (props.icon)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.comps[props.icon]), {
                      key: 0,
                      color: props.iconColor,
                      class: "mr-2"
                    }, null, 8, ["color"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(AtomTitle), {
                  title: props.title,
                  classes: ['title-modal mb-0']
                }, null, 8, ["title"])
              ]),
              _createElementVNode("button", {
                size: "large",
                onClick: close,
                class: "btn-close"
              }, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-close")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(VueGoodTable), {
            isLoading: props.loading,
            ref_key: "table",
            ref: table,
            onSortChange: onSortChange,
            "select-options": {
                    enabled: _ctx.enableOptions,
                    selectOnCheckboxOnly: _ctx.selectOnCheckboxOnly,
                    disableSelectInfo: _ctx.disableSelectInfo,
                },
            "enable-row-expand": _ctx.enableExpand,
            onOnSelectedRowsChange: selectionChanged,
            styleClass: "vgt-table",
            "row-style-class": rowStyleClassFn,
            onRowClick: onRowClick,
            columns: _ctx.headers,
            rows: computedItems.value
          }, _createSlots({
            "row-details": _withCtx((props) => [
              _renderSlot(_ctx.$slots, "bodyCollapse", {
                row: props.row
              })
            ]),
            loadingContent: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(LoaderIcon)), { class: "ma-auto w-100" }))
            ]),
            "table-row": _withCtx((props) => [
              _createElementVNode("div", _hoisted_6, [
                (props.column.type == 'badge')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      (_ctx.update && !!props.column.mode && validLine(props.row))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            (props.column.mode == 'money')
                              ? (_openBlock(), _createBlock(_unref(AtomInputMoney), {
                                  key: 0,
                                  modelValue: updateValues.value[props.column.update],
                                  "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (props.column.mode == 'date')
                              ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                  key: 1,
                                  type: "date",
                                  modelValue: updateValues.value[props.column.update],
                                  "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (props.column.mode == 'input')
                              ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                  key: 2,
                                  modelValue: updateValues.value[props.column.update],
                                  "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            (props.column.mode == 'select')
                              ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                                  key: 3,
                                  width: "154px",
                                  modelValue: updateValues.value[props.column.update],
                                  "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                  options: props.column.options
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock(_unref(AtomBadge), {
                            key: 1,
                            text: props.formattedRow[props.column.field],
                            color: props.row.color,
                            "bg-color": props.row.bgColor
                          }, null, 8, ["text", "color", "bg-color"]))
                    ]))
                  : (props.column.type == 'overlay')
                    ? (_openBlock(), _createBlock(_unref(AtomAvatarOverlay), {
                        key: 1,
                        images: props.formattedRow[props.column.field] ?? [],
                        style: {"margin-top":"-1em"}
                      }, null, 8, ["images"]))
                    : (props.column.type == 'progress')
                      ? (_openBlock(), _createBlock(_unref(AtomPhasedProgress), {
                          key: 2,
                          values: props.formattedRow[props.column.field]
                        }, null, 8, ["values"]))
                      : (props.column.type == 'hint')
                        ? (_openBlock(), _createBlock(_unref(MoleculeTooltipMetas), {
                            key: 3,
                            items: [],
                            "items-only": props.formattedRow[props.column.field],
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.common.display')), 1)
                            ]),
                            _: 2
                          }, 1032, ["items-only"]))
                        : (props.column.field == 'actions')
                          ? _renderSlot(_ctx.$slots, "actions", _mergeProps({ key: 4 }, _ctx.$attrs, { props: props }))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                              (_ctx.update && !!props.column.mode && validLine(props.row))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (props.column.mode == 'money')
                                      ? (_openBlock(), _createBlock(_unref(AtomInputMoney), {
                                          key: 0,
                                          label: props.column.label,
                                          prependIcon: "",
                                          modelValue: updateValues.value[props.column.update],
                                          "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event)
                                        }, {
                                          prependIcon: _withCtx(() => [
                                            _createTextVNode(" $ ")
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "modelValue", "onUpdate:modelValue"]))
                                      : _createCommentVNode("", true),
                                    (props.column.mode == 'date')
                                      ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                          key: 1,
                                          type: "date",
                                          modelValue: updateValues.value[props.column.update],
                                          "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                          label: props.column.label
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                      : _createCommentVNode("", true),
                                    (props.column.mode == 'input')
                                      ? (_openBlock(), _createBlock(_unref(AtomInput), {
                                          key: 2,
                                          modelValue: updateValues.value[props.column.update],
                                          "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                          label: props.column.label
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                                      : _createCommentVNode("", true),
                                    (props.column.mode == 'select')
                                      ? (_openBlock(), _createBlock(_unref(AtomSelect), {
                                          key: 3,
                                          width: "154px",
                                          label: props.column.label,
                                          modelValue: updateValues.value[props.column.update],
                                          "onUpdate:modelValue": ($event: any) => ((updateValues.value[props.column.update]) = $event),
                                          options: props.column.options
                                        }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "options"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    (props.column.extra && props.column.extra.avatar)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                          _createVNode(_component_v_avatar, {
                                            rounded: 8,
                                            color: "grey",
                                            size: "48"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_img, {
                                                cover: "",
                                                src: props.row['avatar']
                                              }, null, 8, ["src"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (props.column.field == 'id')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (props.column.expander)
                                            ? (_openBlock(), _createBlock(_unref(ChevronSolidIcon), {
                                                key: 0,
                                                class: "rotate-invert"
                                              }))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (props.column.type == 'update-margin')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "text-center",
                                            placeholder: props.formattedRow[props.column.field],
                                            "onUpdate:modelValue": ($event: any) => ((updateValues.value[`${props.row.id}_${props.column.update}`]) = $event),
                                            onChange: ($event: any) => (handleUpdate(props.row.id, props.row.invoices_id, props.row.margin, updateValues.value[`${props.row.id}_${props.column.update}`])),
                                            onBlur: ($event: any) => (updateValues.value[`${props.row.id}_${props.column.update}`] = blurMargin(updateValues.value[`${props.row.id}_${props.column.update}`].toString())),
                                            onFocus: ($event: any) => (updateValues.value[`${props.row.id}_${props.column.update}`] = unformatCurrency(updateValues.value[`${props.row.id}_${props.column.update}`]))
                                          }, null, 40, _hoisted_14), [
                                            [_vModelText, updateValues.value[`${props.row.id}_${props.column.update}`]]
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 3,
                                          class: _normalizeClass(props.column.maxLines ? 'overflow-text-table' : '')
                                        }, _toDisplayString(props.formattedRow[props.column.field]), 3)),
                                    (props.column.maxLines)
                                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                          key: 4,
                                          activator: "parent",
                                          location: "top"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(props.formattedRow[props.column.field]), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]))
                            ])),
                (props.column.extra && !props.column.extra.avatar)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass(props.column.classExtra)
                    }, _toDisplayString(props.row[props.column.fieldExtra]), 3))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, [
            (!!_ctx.textEmpty)
              ? {
                  name: "emptystate",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.textEmpty), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["isLoading", "select-options", "enable-row-expand", "columns", "rows"])
        ])
      ]),
      (_ctx.showFooter)
        ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.showFooter)
        ? (_openBlock(), _createBlock(_component_v_footer, {
            key: 2,
            class: "rounded-xl"
          }, {
            default: _withCtx(() => [
              (props.totalItems != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_unref(MoleculePagination), {
                      class: "pagination-component",
                      modelValue: page.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
                      numberOfPages: lengthItems.value,
                      "options-per-page": [10, 15, 20],
                      "total-items": props.totalItems,
                      perPage: perPageTable.value,
                      onChangePerPage: _cache[1] || (_cache[1] = ($event: any) => (perPageTable.value = $event))
                    }, null, 8, ["modelValue", "numberOfPages", "total-items", "perPage"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.enableOptions || _ctx.enableButtons)
        ? (_openBlock(), _createBlock(_component_v_divider, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.enableOptions || _ctx.enableButtons)
        ? (_openBlock(), _createBlock(_component_v_footer, {
            key: 4,
            class: "rounded-xl"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AtomButton), {
                    background: "transparent",
                    outlined: "",
                    "no-hover": "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {showModalQuotation.value = false; showEditDate.value = false; selectedRows.value = []; newDate.value = undefined; itemsUpdates.value = []; clearValues();}),
                    style: {"max-height":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.common.back')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(AtomButton), {
                    background: "primary",
                    class: "ms-sm-4 whitespace-nowrap",
                    onClick: submitEditDate,
                    style: {"max-height":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('message.goals_details.save')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["modelValue", "persistent", "width", "height"]))
}
}

})